import type { AlarmLogApi } from '../../type';

export const ALARM_LOG_KEYS = {
  getInfiniteList: (param?: AlarmLogApi.GetList.Request) =>
    param
      ? (['alarmLogApi.getInfiniteList', param] as const)
      : (['alarmLogApi.getInfiniteList'] as const),
  getCount: (param?: AlarmLogApi.GetCount.Request) =>
    ['alarmLogApi.getCount', JSON.stringify(param ?? {})] as const,
};
